import { StyleControlOptions, InputControlOptions, NumberFormatType } from "./form-control-options";
/**
 * 选人控件可选类型
 */
export var StaffSelectorSelectType;
(function (StaffSelectorSelectType) {
    /**
     * 所有
     */
    StaffSelectorSelectType["All"] = "all";
    /**
     * 用户
     */
    StaffSelectorSelectType["User"] = "user";
    /**
     * 部门
     */
    StaffSelectorSelectType["Org"] = "org";
})(StaffSelectorSelectType || (StaffSelectorSelectType = {}));
/**
 * 选人控件值类型
 */
export var StaffSelectorValueType;
(function (StaffSelectorValueType) {
    /**
     * 空，取设置的固定值
     */
    StaffSelectorValueType["None"] = "";
    /**
     * 创建人，前发起人
     */
    StaffSelectorValueType["Originator"] = "originator";
    /**
     * 创建人部门，前发起人部门
     */
    StaffSelectorValueType["OriginatorDept"] = "originatorDept";
    /**
     * 引用控件值
     */
    StaffSelectorValueType["Ref"] = "ref";
})(StaffSelectorValueType || (StaffSelectorValueType = {}));
export var DisplayType;
(function (DisplayType) {
    DisplayType["Text"] = "text";
    DisplayType["Tag"] = "tag";
})(DisplayType || (DisplayType = {}));
/**
 * 选人控件
 */
export class StaffSelectorOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 是否多选
         */
        this.multi = false;
        /**
         * 是否可选组织
         * all组织和用户 user用户 org组织
         */
        this.deptVisible = StaffSelectorSelectType.All;
        // /**
        //  * 是否可选用户
        //  */
        // userVisible: Boolean = true
        /**
         * 默认值
         */
        this.defaultValue = null;
        /**
         * 默认值类型
         */
        this.defaultValueType = StaffSelectorValueType.None;
        /**
         * 组织根节点
         * 数组：选定的值；字符串：值表达式
         */
        this.orgRoot = null;
        /**
         * 组织根节点值类型
         */
        this.orgRootValueType = StaffSelectorValueType.None;
        /**
         * 递归的
         */
        this.recursive = true;
        /**
         * 角色范围
         */
        this.roles = "";
        /**
         * 映射关系
         */
        this.mappings = "";
        this.displayType = DisplayType.Tag;
    }
}
/**
 * 上传限制
 */
export var UploadLimitType;
(function (UploadLimitType) {
    UploadLimitType["1M"] = "1M";
    UploadLimitType["5M"] = "5M";
    UploadLimitType["10M"] = "10M";
    UploadLimitType["20M"] = "20M";
    UploadLimitType["50M"] = "50M";
    UploadLimitType["100M"] = "100M";
    UploadLimitType["200M"] = "200M";
    // '512M' = '512M',
    // '1G' = '1G'
})(UploadLimitType || (UploadLimitType = {}));
export class UploadOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 显示条件
         */
        this.displayFormula = "";
        /**
         * 必填条件
         */
        this.requiredFormula = "";
        /**
         * 文件大小限制
         */
        // limit: string | null = '10M'
        this.limit = "5M";
        /**
         * 批量下载
         */
        this.batch = true;
    }
}
export class BaseUploadOptions extends UploadOptions {
    constructor() {
        super(...arguments);
        /**
         * 上传附件事件
         */
        this.onUpload = null;
        /**
         * 删除附件事件
         */
        this.onDelete = null;
    }
}
/**
 * 附件
 */
export class AttachmentOptions extends BaseUploadOptions {
    constructor() {
        super(...arguments);
        /**
         * 文件类型
         */
        this.fileTypes = null;
    }
}
/**
 * 图片
 */
export class ImageUploadOptions extends BaseUploadOptions {
    constructor() {
        super(...arguments);
        /**
         * 上传数量 单张 unique 多张 batch
         */
        this.number = "batch";
        /**
         * 水印
         */
        this.addWatermark = false;
        /**
         * 图片质量30...100
         */
        this.imageQuality = 50;
        /**
         * 可压缩
         */
        this.compressible = false;
        /**
         * 是否只允许拍照
         */
        this.onlyShoot = false;
    }
}
/**
 * 手写签名
 */
export class SignatureUploadOptions extends UploadOptions {
    constructor() {
        super(...arguments);
        this.displayEnd = "移动端";
    }
}
/**
 * 审批意见
 */
export class ApprovalOpinionOptions extends UploadOptions {
    constructor() {
        super(...arguments);
        /**
         * 上传附件
         */
        this.showUpload = true;
        /**
         * 上传文件格式
         */
        this.fileTypes = null;
        /**
         * 默认审批意见
         */
        this.defaultValue = null;
        /**
         * 手写签名
         */
        this.showSignature = true;
        /**
         * 手写签名是否必填
         */
        this.signatureIsRequired = false;
        // /**
        //  * 显示常用意见
        //  */
        // showCommon: Boolean = true;
        // /**
        //  * 显示设置常用意见
        //  */
        // showCommonSetting: Boolean = true;
        // /**
        //  * 只显示最后一条意见
        //  */
        // onlyShowLast: Boolean = false;
    }
}
/**
 * 子表显示模式
 */
export var SheetDisplayMode;
(function (SheetDisplayMode) {
    /**
     * 瀑布
     */
    SheetDisplayMode["Waterfall"] = "waterfall";
    /**
     * 分页
     */
    SheetDisplayMode["Page"] = "page";
    /**
     * 二维
     */
    SheetDisplayMode["Table"] = "table";
})(SheetDisplayMode || (SheetDisplayMode = {}));
/**
 * 子表子表
 */
export class SheetOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 默认行数
         */
        this.rows = 2;
        /**
         * 能否编辑
         */
        this.editable = true;
        /**
         * 能否导入
         */
        this.importable = true;
        /**
         * 能否导出
         */
        this.exportable = true;
        this.importFormRelevanceForm = '';
        /**
         * 显示合计
         */
        this.showTotal = false;
        /**
         * 显示条件
         */
        this.displayFormula = "";
        /**
         * 行新增事件
         */
        this.onAddRow = null;
        /**
         * 行删除事件
         */
        this.onDeleteRow = null;
        /**
         * 移动端显示模式
         */
        this.mobileDisplayMode = SheetDisplayMode.Page;
        this.showAllEdit = false;
        this.sheetFiters = [];
        // /**
        //  * 渲染前事件
        //  */
        // onLoadBefore: string | null = null
        // /**
        //  * 渲染后事件
        //  */
        // onLoadAfter: string | null = null
    }
}
/**
 * 计算模式
 */
export var AggregateType;
(function (AggregateType) {
    /**
     * 不计算、不统计
     */
    AggregateType["None"] = "none";
    /**
     * 求和
     */
    AggregateType["Sum"] = "sum";
    /**
     * 平均
     */
    AggregateType["Avg"] = "avg";
    /**
     * 最小值
     */
    AggregateType["Min"] = "min";
    /**
     * 最大值
     */
    AggregateType["Max"] = "max";
})(AggregateType || (AggregateType = {}));
/**
 * 子表统计选项
 */
export class SheetStatisticOptions {
    constructor() {
        /**
         * 统计模式
         */
        this.statisticMode = AggregateType.Sum;
        /**
         * 显示格式
         */
        this.format = NumberFormatType.Int;
    }
}
export var RelevanceFormSelectMode;
(function (RelevanceFormSelectMode) {
    RelevanceFormSelectMode["Popup"] = "popup";
    RelevanceFormSelectMode["Dropdown"] = "dropdown";
})(RelevanceFormSelectMode || (RelevanceFormSelectMode = {}));
/**
 * 关联表单
 */
export class RelevanceFormOptions extends InputControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 业务模型
         */
        this.schemaCode = "";
        /**
         * 查询列表编码
         */
        this.queryCode = "";
        /**
         * 显示字段
         * @URL http://redmine.h3bpm.com/issues/31131
         */
        this.displayField = "name";
        /**
         * 查询条件
         */
        this.conditions = "";
        /**
         * 移动端查询条件
         */
        this.mobileConditions = "";
        /**
         * 映射字段
         */
        this.mappings = "";
        /**
         * 显示链接模式
         */
        this.linkMode = true;
        /**
         * 选择数据方式
         * popup弹出框 | dropdown下拉框
         */
        this.selectMode = RelevanceFormSelectMode.Popup;
        /**
         * 临时授权
         */
        this.isAuthorize = true;
        // 默认值
        this.defaultVal = "";
    }
}
export var DispalyMode;
(function (DispalyMode) {
    DispalyMode["Link"] = "link";
    DispalyMode["List"] = "list";
})(DispalyMode || (DispalyMode = {}));
export var ListDispalyMode;
(function (ListDispalyMode) {
    ListDispalyMode["Table"] = "table";
    ListDispalyMode["Tabs"] = "tabs";
})(ListDispalyMode || (ListDispalyMode = {}));
/**
 * 反向关联 关联查询
 */
export class ReverseRelevanceOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 业务模型
         */
        this.schemaCode = "";
        /**
         * 关联字段
         */
        this.fieldCode = "";
        /**
         * 显示模式
         */
        this.displayMode = DispalyMode.List;
        /**
         * 列表编码
         */
        this.listCode = "";
        /**
         * 临时授权
         */
        // isAuthorize: boolean = true
        /**
         * 展示方式
         */
        this.listDisplayMode = ListDispalyMode.Table;
        /**
         * 查询条件
         */
        this.conditions = "";
        /**
         * 移动端查询条件
         */
        this.mobileConditions = "";
        // appPackageCode = ''
        // appFunctionCode = ''
    }
}
